import { CarouselButtons, Stack, XStack, YStack, useCarousel, SizableText } from '@my/ui'

import { DisplayStyle, FeaturedOffersBlock } from './featured-offers.block'
import { OfferCardContent } from './components/offer-card-content'

export const FeaturedOffersComponent = (block: FeaturedOffersBlock) => {
  const carousel = useCarousel()

  const displayStyle = block.displayStyle as DisplayStyle
  const withBackgroundImage = block.cardType === 'withBackgroundImage'
  const complexView = block.cardType === 'complexView'
  const showEndTime = block.showEndTime

  switch (displayStyle) {
    case 'carousel':
      // Basic card has 3 columns when carousel
      // Complex and withBg card has 2 columns when carousel
      const basicCardWrapper = {
        w: 150,
        h: 200,
        $gtXs: {
          w: 286,
          h: 390,
        },
      }

      const complexCardWrapper = {
        w: 'calc(50% - 8px)',
        h: 'auto',
      }

      const withBgCardWrapper = {
        w: '90%',
        h: 'auto',
        $gtXs: {
          w: 440,
        },
      }

      const wrapperStyles = withBackgroundImage
        ? withBgCardWrapper
        : complexView
        ? complexCardWrapper
        : basicCardWrapper

      return (
        <Stack
          position="relative"
          className="overflow-x-hidden"
          py="$3"
          my="$-3"
          w="100%"
          ref={carousel.emblaRef as any}
        >
          <XStack gap="$3.5" height="auto">
            {block.offers &&
              block.offers.map((item, index) => (
                <Stack key={item.id} {...wrapperStyles}>
                  <OfferCardContent
                    offer={item}
                    showEndTime={showEndTime}
                    complexView={complexView}
                    withBackgroundImage={withBackgroundImage}
                    imagePriority={index >= 3 && block.imagePriority}
                  />
                </Stack>
              ))}
          </XStack>
          <CarouselButtons carousel={carousel} />
        </Stack>
      )

    case 'grid':
      return (
        <YStack>
          <XStack gap="$3.5" flexWrap="wrap" justifyContent="space-between">
            {block.offers &&
              block.offers.map((item, index) => (
                <Stack
                  width="100%"
                  key={item.id}
                  $gtXss={{ width: withBackgroundImage ? '100%' : 'calc(50% - 8px)' }}
                  $gtMd={{ width: 'calc(50% - 8px)' }}
                >
                  <OfferCardContent
                    offer={item}
                    showEndTime={showEndTime}
                    complexView={complexView}
                    withBackgroundImage={withBackgroundImage}
                    imagePriority={index >= 4 && block.imagePriority}
                  />
                </Stack>
              ))}
          </XStack>
        </YStack>
      )

    default:
      return null
  }
}
